export function ParseGraphqlError(error) {
  let err = error.toString().replace("Error: GraphQL error: ", "").replace("Error: ", "");
  return err;
}


// WEBPACK FOOTER //
// ./src/helpers/ErrorHelper.js